import React, { useState, useEffect } from "react";
import style from "./ContentContainer.module.css";
import Content from "../Content/Content";
import placeholder from "../../assets/images/stuff/placeholder.png";
import iconsplaceholder from "../../assets/images/stuff/iconsplaceholder.png";
import slide1_1 from "../../assets/newImages/ram_w1_v1_th.webp";
import slide1_2 from "../../assets/newImages/ram_w1_v2_th.webp";
import icon1 from "../../assets/images/slidesmobile/icons1.png";
import sticker0 from '../../assets/allStickersNew/stickerBill.svg';
import sticker1 from '../../assets/allStickersNew/stickerCallMe.svg';
import sticker2 from '../../assets/allStickersNew/stickerCans.svg';
import sticker3 from '../../assets/allStickersNew/stickerGoodWork.svg';
import sticker4 from '../../assets/allStickersNew/stickerGottaGo.svg';
import sticker5 from '../../assets/allStickersNew/stickerHappy.svg';
import sticker6 from '../../assets/allStickersNew/stickerLetsGo.svg';
import sticker7 from '../../assets/allStickersNew/stickerLowEnergy.svg';
import sticker8 from '../../assets/allStickersNew/stickerMissYou.svg';
import sticker9 from '../../assets/allStickersNew/stickerNice100.svg';
import sticker10 from '../../assets/allStickersNew/stickerPleasure.svg';
import sticker11 from '../../assets/allStickersNew/stickerStayHome.svg';
import download from "../../assets/images/stickers/download.svg";
import week1 from "../../assets/images/allStickers/week1.svg";
import week2 from "../../assets/images/allStickers/week2.svg";
import week3 from "../../assets/images/allStickers/week3.svg";
import week4 from "../../assets/images/allStickers/week4.svg";
import allContent from "../../allContent";

import useLocalStorageState from "use-local-storage-state";
import Gift from "../Gift/Gift";

const ContentContainer = ({
  phase,
  setPhase,
  setOpenVideo,
  setVideo,
  setShowDialog,
  setDialogContent,
  timestamps,
  buttonBottom,
}) => {
  const [seen1, setSeen1] = useLocalStorageState("seen1", false);
  const [seen2, setSeen2] = useLocalStorageState("seen2", false);
  const [seen3, setSeen3] = useLocalStorageState("seen3", false);
  const [seen4, setSeen4] = useLocalStorageState("seen4", false);
  const [seen5, setSeen5] = useLocalStorageState("seen5", false);
  const [seen6, setSeen6] = useLocalStorageState("seen6", false);
  const [seen7, setSeen7] = useLocalStorageState("seen7", false);

  const [seenAll, setSeenAll] = useLocalStorageState("seenAll", false);

  const [seenMeme1, setSeenMeem1] = useLocalStorageState("seenMeme1", false);
  const [seenMeme2, setSeenMeem2] = useLocalStorageState("seenMeme2", false);
  const [seenMeme3, setSeenMeem3] = useLocalStorageState("seenMeme3", false);
  const [seenMeme4, setSeenMeem4] = useLocalStorageState("seenMeme4", false);
  const [seenMeme5, setSeenMeem5] = useLocalStorageState("seenMeme5", false);
  const [seenMeme6, setSeenMeem6] = useLocalStorageState("seenMeme6", false);

  const [sticker1Claimed, setSticker1Claimed] = useLocalStorageState(
    "sticker1Claimed",
    false
  );
  const [sticker2Claimed, setSticker2Claimed] = useLocalStorageState(
    "sticker2Claimed",
    false
  );
  const [sticker3Claimed, setSticker3Claimed] = useLocalStorageState(
    "sticker3Claimed",
    false
  );
  const [sticker4Claimed, setSticker4Claimed] = useLocalStorageState(
    "sticker4Claimed",
    false
  );

  useEffect(() => {
    if (seen1 && seen2 && seen3 && seen4 && seen5 && seen6 && seen7) {
      setSeenAll(true);
    }
  }, [seen1, seen2, seen3, seen4, seen5, seen6, seen7]);

  const content = [
    {
      episode: allContent.week1.episode,
      title: allContent.week1.title,
      videos: [
        {
          img: allContent.week1.thumbnailImg1,
          url: allContent.week1.video1,
          seen: seen1,
          setSeen: setSeen1,
          videoId: "RAM_BTN_Week1_Video1",
          title: allContent.week1.thumbnailTitle1,
        },
        {
          img: allContent.week1.thumbnailImg2,
          url: allContent.week1.video2,
          seen: seen2,
          setSeen: setSeen2,
          videoId: "RAM_BTN_Week1_Video2",
          title: allContent.week1.thumbnailTitle2,
        },
      ],
      text: allContent.week1.description,
      stickers: [allContent.week1.sticker, sticker1, sticker2],
      icon: icon1,
      memes: [allContent.week1.gif1, allContent.week1.gif2],
      posters: [
        {
          url: allContent.week1.posterMeme1,
          memeId: "RAM_BTN_Week1_Meme1",
          seen: seenMeme1,
          setSeen: setSeenMeem1,
        },
        {
          url: allContent.week1.posterMeme2,
          memeId: "RAM_BTN_Week1_Meme2",
          seen: seenMeme2,
          setSeen: setSeenMeem2,
        },
      ],
      placeholders: [placeholder, sticker0],
      timestamp: timestamps[0],
      seen: seen1 && seen2,
      claimId: "RAM_BTN_Week1_StickerClaim",
      setClaimed: setSticker1Claimed,
      claimed: sticker1Claimed,
      allStickers: allContent.week1.multipleSticker,
    },
    {
      episode: allContent.week2.episode,
      title: allContent.week2.title,
      videos: [
        {
          img: allContent.week2.thumbnailImg1,
          url: allContent.week2.video1,
          seen: seen3,
          setSeen: setSeen3,
          videoId: "RAM_BTN_Week2_Video1",
          title: allContent.week2.thumbnailTitle1,
        },
        {
          img: allContent.week2.thumbnailImg2,
          url: allContent.week2.video2,
          seen: seen4,
          setSeen: setSeen4,
          videoId: "RAM_BTN_Week2_Video2",
          title: allContent.week2.thumbnailTitle2,
        },
      ],
      text: allContent.week2.description,
      stickers: [allContent.week2.sticker, sticker3, sticker5],
      icon: icon1,
      memes: [allContent.week2.gif1, allContent.week2.gif2],
      posters: [
        {
          url: allContent.week2.posterMeme1,
          memeId: "RAM_BTN_Week2_Meme1",
          seen: seenMeme3,
          setSeen: setSeenMeem3,
        },
        {
          url: allContent.week2.posterMeme2,
          memeId: "RAM_BTN_Week2_Meme2",
          seen: seenMeme4,
          setSeen: setSeenMeem4,
        },
      ],
      placeholders: [placeholder, sticker3],
      timestamp: timestamps[1],
      seen: seen3 && seen4,
      claimId: "RAM_BTN_Week2_StickerClaim",
      setClaimed: setSticker2Claimed,
      claimed: sticker2Claimed,
      allStickers: allContent.week2.multipleSticker,
    },
    {
      episode: allContent.week3.episode,
      title: allContent.week3.title,
      videos: [
        {
          img: allContent.week3.thumbnailImg1,
          url: allContent.week3.video1,
          seen: seen5,
          setSeen: setSeen5,
          videoId: "RAM_BTN_Week3_Video1",
          title: allContent.week3.thumbnailTitle1,
        },
        {
          img: allContent.week3.thumbnailImg2,
          url: allContent.week3.video2,
          seen: seen6,
          setSeen: setSeen6,
          videoId: "RAM_BTN_Week3_Video2",
          title: allContent.week3.thumbnailTitle2,
        },
      ],
      text: allContent.week3.description,
      stickers: [allContent.week3.sticker, sticker0, sticker6],
      icon: icon1,
      memes: [allContent.week3.gif1, allContent.week3.gif2],
      posters: [
        {
          url: allContent.week3.posterMeme1,
          memeId: "RAM_BTN_Week3_Meme1",
          seen: seenMeme5,
          setSeen: setSeenMeem5,
        },
        {
          url: allContent.week3.posterMeme2,
          memeId: "RAM_BTN_Week3_Meme2",
          seen: seenMeme6,
          setSeen: setSeenMeem6,
        },
      ],
      placeholders: [placeholder, sticker8],
      timestamp: timestamps[2],
      seen: seen5 && seen6,
      claimId: "RAM_BTN_Week3_StickerClaim",
      setClaimed: setSticker3Claimed,
      claimed: sticker3Claimed,
      allStickers: allContent.week3.multipleSticker,
    },
    {
      episode: allContent.week4.episode,
      title: allContent.week4.title,
      videos: [
        {
          img: allContent.week4.thumbnailImg1,
          url: allContent.week4.video1,
          seen: seen7,
          setSeen: setSeen7,
          videoId: "RAM_BTN_Week4_Video1",
          title: allContent.week4.thumbnailTitle1,
        },
      ],
      text: allContent.week4.description,
      stickers: [allContent.week4.sticker, sticker9, sticker10],
      placeholders: [placeholder, sticker10],
      memes: [],
      posters: [
        // {
        //   url: poster1,
        //   memeId: "RAM_BTN_Week4_Meme1",
        //   seen: seenMeme1,
        //   setSeen: setSeenMeem1,
        // },
      ],
      timestamp: timestamps[3],
      seen: seen7,
      claimId: "RAM_BTN_Week4_StickerClaim",
      setClaimed: setSticker4Claimed,
      claimed: sticker4Claimed,
      allStickers: allContent.week4.multipleSticker,
    },
    {
      episode: false,
      title: allContent.gift.getGift,
      videos: [
        {
          img: slide1_1,
        },
        { img: slide1_2 },
      ],
      text: "See how your simple gestures can take people places and bring them together.",
      stickers: [download, "2", "3"],
      placeholders: [placeholder, iconsplaceholder],
      timestamp: timestamps[3],
      
    },
  ];
  return (
    <div
      className={phase === 0 ? style.contentContainer : style.contentContainer1}
      style={{ top: phase === 0 ? `${buttonBottom}px` : "66px" }}
    >
      <div className={style.container}>
        {content.map((item, index) => {
          if (item.episode) {
            return (
              <Content
                key={index}
                item={item}
                index={index}
                phase={phase}
                setPhase={setPhase}
                setOpenVideo={setOpenVideo}
                setVideo={setVideo}
                setDialogContent={setDialogContent}
                setShowDialog={setShowDialog}
              />
            );
          } else {
            return (
              <Gift
                key={index}
                item={item}
                index={index}
                phase={phase}
                setPhase={setPhase}
                setOpenVideo={setOpenVideo}
                setVideo={setVideo}
                setDialogContent={setDialogContent}
                setShowDialog={setShowDialog}
                seenAll={seenAll}
              />
            );
          }
        })}
      </div>
    </div>
  );
};

export default ContentContainer;
